import React from "react";
import type { TypedWrappedFieldProps } from "redux-form";

import type { AutocompleteRenderInputParams } from "@braintrust/braintrust-ui-components";

// Todo: refactor this factory component to fix the types
export type ReduxFormAutocompleteFactoryInjectedProps =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TypedWrappedFieldProps<any> & {
    noErrorOnTouch?: boolean;
    renderInput: (
      params: AutocompleteRenderInputParams,
      state: { isError: boolean; error: string },
    ) => React.ReactNode;
  };

export const ReduxFormAutocompleteFactory = (Component: React.ElementType) => {
  return ({
    input,
    meta: { error, touched, submitFailed },
    noErrorOnTouch,
    multiple,
    renderInput,
    ...props
  }: ReduxFormAutocompleteFactoryInjectedProps & { multiple?: boolean }) => {
    const { onChange, value } = input;

    const _value = multiple ? (Array.isArray(value) ? value : []) : value;
    const isError = Boolean(
      (submitFailed || (!noErrorOnTouch && touched)) && error,
    );

    return (
      <Component
        multiple={multiple}
        onChange={onChange}
        value={_value}
        {...props}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        renderInput={(params: any) => {
          return renderInput(params, { isError, error });
        }}
      />
    );
  };
};
